import { render } from "./PageHeader.vue?vue&type=template&id=7c4ca7b1&scoped=true&ts=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=7c4ca7b1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4ca7b1"]])

export default __exports__